import { Controller } from '@hotwired/stimulus'

// Bootstrap's Tab deactivates siblings within the trigger's own tablist, and the admin
// trigger sits in the footer's list rather than the rail's — so activating it left the
// previously open pane showing. This deactivates every pane in the sidebar first.
export default class extends Controller {
  connect() {
    this.onShow = this.deactivateOthers.bind(this)
    this.element.addEventListener('show.bs.tab', this.onShow)
  }

  disconnect() {
    this.element.removeEventListener('show.bs.tab', this.onShow)
  }

  deactivateOthers(event) {
    const target = document.querySelector(event.target.getAttribute('href'))

    for (const pane of this.element.querySelectorAll('.tab-pane')) {
      if (pane !== target) pane.classList.remove('show', 'active')
    }

    for (const trigger of this.element.querySelectorAll('[data-bs-toggle="pill"]')) {
      if (trigger !== event.target) {
        trigger.classList.remove('active')
        trigger.setAttribute('aria-selected', 'false')
      }
    }
  }
}
